























import { Component, Prop,  Mixins } from "vue-property-decorator";

import { UserProxy } from "@/types/api/userProxy";

import { userProxyList} from "@/api/userProxy";

// 混入
import Loading from "@/mixins/loading";

@Component
export default class Header extends Mixins(Loading) {
  @Prop([String]) private keyword!: string;
  tableData: Array<UserProxy> = [];

  /**
   * methods
   */
  getData() {
    this.showLoading();
    userProxyList().then((res: any) => {
      this.tableData = res.data;
      this.hideLoading();
    });
  }
  // 表头样式
  headerCellStyle() {
    return {
      background: '#eef1f6', color: '#606266', textAlign: 'center'
    }
  }
  // 列表样式
  cellStyle() {
    return {
      textAlign: 'center'
    }
  }

}
